module.exports = __webpack_public_path__ + "img/bb-wh.ea232db9.svg";